import { render, staticRenderFns } from "./SetupActivate.vue?vue&type=template&id=aab65294&"
import script from "./SetupActivate.vue?vue&type=script&lang=js&"
export * from "./SetupActivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports